import React, { forwardRef, useRef } from "react";
import Styles from "./ProgramCurtators.module.scss";
import { useEffect } from "react";
import { appLevelConstants } from "../../constants/AppLevelConstants";
import { FaLinkedinIn } from "react-icons/fa";
import { HiArrowTopRightOnSquare } from "react-icons/hi2";
import { useLocation } from "react-router-dom";

const ProgramCurtators = forwardRef(({ scrollToId }, ref) => {
  const location = useLocation();

  const isFoundersPage = location.pathname === "/aboutUs/founders";

  const headingAccent = isFoundersPage ? "Founders" : "Team";

  const profileRefs = useRef({});

  const scrollToProfile = (id) => {
    const profileRef = profileRefs.current[id];
    if (profileRef) {
      profileRef.scrollIntoView({ behavior: "smooth", block: "start" });
      setTimeout(() => {
        profileRef.style.marginTop = "160px";
      }, 500);
    }
  };

  useEffect(() => {
    if (scrollToId !== undefined) {
      const timer = setTimeout(() => {
        scrollToProfile(scrollToId);
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [scrollToId]);

  return (
    <div ref={ref} className={Styles["program-curtators"]}>
      <div className={Styles["inner"]}>
        <header className={Styles["sectionHead"]}>
          <p className={Styles["kicker"]}>Our leadership</p>
          <h2 className={Styles["heading"]}>
            <span className={Styles["headingLine1"]}>Meet the Iron Lady</span>
            <span className={Styles["headingAccent"]}>{headingAccent}</span>
          </h2>
          <p className={Styles["subhead"]}>
            {isFoundersPage
              ? "The people building India’s flagship platform for women leaders."
              : "The minds behind our programs and your growth."}
          </p>
        </header>
        <div className={Styles["cardList"]}>
          {appLevelConstants.program.programs.map((item, index) => {
            const isReverse = index % 2 === 1;
            return (
              <div
                key={item.id}
                ref={(el) => {
                  profileRefs.current[item.id] = el;
                }}
                className={Styles["leader"]}
              >
                <article
                  className={`${Styles["leaderCard"]} ${
                    isReverse ? Styles["leaderCardReverse"] : ""
                  }`}
                >
                  <div className={Styles["leaderVisual"]}>
                    <div className={Styles["photoFrame"]}>
                      <img
                        className={Styles["leaders-image"]}
                        alt={item.name || ""}
                        src={item.img}
                      />
                    </div>
                  </div>
                  <div className={Styles["leaderBody"]}>
                    <div className={Styles["profileHeader"]}>
                      <h3 className={Styles["leader-name"]}>{item.name}</h3>
                      <p className={Styles["leader-post"]}>{item.post}</p>
                      <a
                        className={Styles["linkedinPill"]}
                        href={item.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`${item.name} on LinkedIn`}
                      >
                        <span className={Styles["linkedinIconTile"]} aria-hidden="true">
                          <FaLinkedinIn className={Styles["linkedinIcon"]} />
                        </span>
                        <span className={Styles["linkedinText"]}>
                          <span className={Styles["linkedinLabel"]}>LinkedIn</span>
                          <span className={Styles["linkedinHint"]}>View profile</span>
                        </span>
                        <HiArrowTopRightOnSquare
                          className={Styles["linkedinExternal"]}
                          aria-hidden
                        />
                      </a>
                    </div>
                    <div
                      className={Styles["description"]}
                      dangerouslySetInnerHTML={{ __html: item.content }}
                    />
                  </div>
                </article>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
});

export default ProgramCurtators;
